import NotePage from 'components/notePage/notePage.component';
import media from 'style-utils/media-queries';
import styled from 'styled-components';

export const OtpNote = styled(NotePage)`
  margin-top: 16px;
  > span {
    > span {
      display: block;
    }
  }
  ${media.desktop`
    > span {
      > span {
        display: inline;
      }
    }
  `}
`;
